import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import placeAPI from "api/placeAPI";

const getPlace = createAsyncThunk(
  "GET_LIST_PLACE",
  async (_arg, { rejectWithValue }) => {
    try {
      let isInLine = false;
      const res = await placeAPI.getPlace(_arg);
      if( res.sorrypage == '0') {
        return {
          place: null,
          isInLine: true
        }
      }
      return {
        place: res.data.place,
        isInLine: res.data.isInLine
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getDetailPlace = createAsyncThunk(
  "GET_PLACE",
  async (_arg, { rejectWithValue }) => {
    try {
      const res = await placeAPI.getDetailPlace(_arg);
      if( res.sorrypage == '0') {
        return {
          data: {},
          isInLine: true
        };
      }
      return {
        data: res.data,
        isInLine: res.data.isInLine
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  category: null,
  data: null,
  place: null,
  isInLine: false
};

const placeSlice = createSlice({
  name: "place",
  initialState,
  extraReducers: {
    [getPlace.fulfilled]: (state, action) => {
      state.category = action.payload.category;
      state.place = action.payload.place;
      state.isInLine = action.payload.isInLine;
    },

    [getDetailPlace.fulfilled]: (state, action) => {
      state.place = action.payload.data;
      state.isInLine = action.payload.isInLine;
    },
  },
});

const { reducer } = placeSlice;
export { getPlace, getDetailPlace };
export default reducer;
